function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#F0C6B4",
  d: "M41.72,77.548c-0.018-0.459,0.965-1.447,1.526-3.062c0.481-1.343,0-2.229,0.962-4.004 c1.269-1.679,4.76,0.315,4.76,0.315s0.689,6.487-0.493,9.254c-1.198,2.76-4.459,4.678-5.986,3.183c-1.033-1-0.116-4.49-0.116-4.49 S41.76,78.396,41.72,77.548z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C6B4",
  d: "M40.244,38.285c1.423,0.691,2.032,1.007,2.032,1.007s0.344,3.256,0.442,6.628 c2.595,6.182,2.809,14.852,4.911,21.234c-0.77,1.648-2.58,2.188-3.993,1.181c-2.051-3.721-8.203-12.78-7.369-21.38 C35.303,40.895,35.536,39.648,40.244,38.285z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D86221",
  d: "M40.492,22.737c2.458,4.724,2.526,15.358,2.449,18.584c-0.071,3.221-7.324,3.738-7.591,1.019 c-0.274-2.736-2.344-23.646-2.344-23.646S38.606,19.117,40.492,22.737z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C7A495",
  d: "M19.155,16.448c-0.601-0.987,1.756-2.266,1.756-2.266l5.533,0.687l5.599,5.799l0.727,4.601l-3.263,2.191 l-5.104-0.194l-4.643-2.916l-0.804-3.335C18.957,21.016,19.877,19.521,19.155,16.448z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M7.027,126.304c9.362-5.41,24.549-5.41,33.913,0.011c9.368,5.401,9.374,14.17,0,19.574 c-9.364,5.41-24.551,5.41-33.913,0C-2.343,140.484-2.343,131.716,7.027,126.304z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#603913",
  d: "M30.987,124.356c2.429,3.713,9.927,3.438,11.613,6.522c0.613,0.941,1.112,2.595-0.226,3.21 c-4.039,0.98-10.985-1.693-10.985-1.693s-7.913,0.64-8.752-0.649c-1.053-1.619-0.379-7.023-0.379-7.023 S30.373,123.479,30.987,124.356z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#073156",
  d: "M21.99,73.771c0,0,19.213-11.938,19.501-9.04c0.999,14.463-6.959,30.11-7.579,33.315 c-1.337,11.354-0.378,23.149-0.291,26.147c0.066,2.48-10.985,4.949-12.026,0.529c-0.758-4.945-0.068-19.38,2.369-25.447 C24.698,96.491,21.99,73.771,21.99,73.771z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#603913",
  d: "M9.056,132.697l6.56-0.754c0,0,0,3.343,0.419,4.38c0.667,2.804,4.227,7.284,2.775,9.835 c-1.018,1.763-4.942,1.036-7.069-0.621c-2.125-1.648-4.26-6.948-4.26-9.756C7.48,133.8,9.056,132.697,9.056,132.697z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FB7422",
  d: "M15.46,25.27c0,0,2.249-1.52,3.496-4.254c-0.439-0.402,6.725,5.835,9.896,3.784 c2.394-1.339,1.03-3.333,1.03-3.333l1.809-3.644c0,0,10.44,6.196,10.44,15.131c0,4.441-1.898,24.798-1.898,24.798 s-3.415,1.756-7.873,4.194c-1.675,0.92-4.459,1.996-3.917,4.821c-6.701,0.813-11.12-4.86-10.371-6.205 c1.457-5.887-2.664-10.589-2.573-12.229C15.606,46.69,8.85,30.674,8.85,30.674l2.917-2.119L15.46,25.27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#083D77",
  d: "M9.58,102.522c1.448-3.843,3.365-31.244,4.191-34.187c0.829-2.942,4.301-7.774,4.301-7.774 s1.621,4.827,7.174,5.115c4.456,0.226,16.113-8.166,16.113-8.166c0.631,4.058,0.443,7.597,0.443,9.13 c0,1.183-4.255,6.927-13.333,13.14c-1.184,7.209-7.177,23.149-10.252,28.894c-0.766,4.704-1.074,12.782-0.766,25.022 c-1.066,3.47-10.56,4.553-11.022-0.149c-0.472-4.707-0.363-20.553,0.328-23.5C7.452,107.104,8.125,106.381,9.58,102.522z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#083D77",
  d: "M25.491,15.578c13.009,4.968,15,14.584,15,14.584l-2.477,1.714c0,0-2.598-11.521-15.123-14.062 C22.897,17.026,24.599,15.804,25.491,15.578z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#083D77",
  d: "M41.061,28.891c2.212,15.114,0.298,28.619,0.298,28.619l-2.299,3.861l-6.832,5.864 c0,0-8.885,3.489-7.856,0.168c3.791-10.052-0.506-28.486-0.506-28.486S35.583,34.754,41.061,28.891z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#083D77",
  d: "M15.46,25.27C26.522,28.783,29.138,38.01,29.138,38.01L25.33,39.5c0,0-2.894-10.193-13.563-10.944 C11.788,27.756,14.564,25.492,15.46,25.27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C6B4",
  d: "M20.396,4.593l4.435-2.76l2.267,0.874c0,0,2.578,0.198,3.18,0.641c3.206,2.309,3.917,5.651,3.971,9.106 c0.355,2.839-0.6,9.878-1.424,10.77c-0.802,0.886-2.391,1.395-2.941,1.433c-1.623,0.144-7.181-3.646-7.995-4.652 c-0.812-1.004-0.667-2.558-0.667-2.558s-2.642,0.01-2.835-3.162c-1.685-2.07-0.086-5.122-0.086-5.122L20.396,4.593z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#603913",
  d: "M20.318,1.063c7.163-4.422,12.285,2.506,9.775,4.737c-1.967,1.937-7.298-1.901-8.843-0.182 c-1.528,1.724,0.87,2.586,1.27,3.882c0.4,1.284,0.493,5.158,0.147,5.521c-0.327,0.362-1.48,0.236-2.027-0.651 c-0.54-0.893-0.431-1.272-1.149-2.035c-2.251-1.905-1.277,1.265-1.092,2.023C17.5,14.604,13.336,5.693,20.318,1.063z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C6B4",
  d: "M25.394,52.322c0,0,0.97,4.163,1.529,5.774c6.431,1.551,15.748,7.189,19.432,8.434 c0.303,0.075,0.838,0.27,2.164,0.171c1.343-0.102,3.603-1.535,4.902,0.452c-0.841,0.377-1.299,1.566-1.334,2.024 c1.029,3.946,5.259,4.652,5.259,4.652s-0.041,1.072-0.965,1.838c-0.925,0.775-6.107,1.015-7.139-0.601 c-0.916-1.433-3.029-3.206-3.029-3.206s-0.999-0.605-1.524-0.819c-7.779-2.602-17.914-0.96-22.98-7.616 c-1.772-2.623-2.912-4.936-3.636-6.502C15.149,54.077,23.841,51.699,25.394,52.322z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D86221",
  d: "M19.342,38.156c2.235,5.069,3.725,8.797,6.621,14.295c1.442,3.001-7.063,7.602-9.2,5.553 C16.141,56.627,1.972,37.313,8.195,31C9.431,29.714,16.378,31.414,19.342,38.156z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M61.359,66.777l0.457,5.887l-2.594,0.226c0,0-2.571-1.475-2.104-5.817 C58.704,67.027,61.359,66.777,61.359,66.777z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.027,66.264c0.694-0.156,13.704-0.919,13.704-0.919S93.628,53.25,99.433,55.89c7.291,3.301,1.15,10.374,1.15,10.374 l-22.524,8.683c0,0-14.513-1.015-16.496-1.159C59.584,73.655,58.192,67.721,61.027,66.264z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C7A496",
  d: "M92.979,51.161l1.026,6.349l-11.879,3.171c0,0,0.262-5.172-0.569-6.91 C81.287,53.514,92.979,51.161,92.979,51.161z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M60.092,164.33c9.527-5.494,24.971-5.494,34.502,0.007c9.527,5.497,9.527,14.417,0,19.922 c-9.531,5.498-24.975,5.498-34.506,0C50.552,178.754,50.552,169.834,60.092,164.33z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#262626",
  d: "M87.874,159.815l8.545,4.716c0,0,2.448,8.847-1.676,8.841c-2.681,0.2-3.939-2.979-6.602-6.065 c-1.887-2.184-4.039-3.938-4.067-4.874C84.004,160.158,87.874,159.815,87.874,159.815z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.583,134.653c5.41,11.338,3.354,25.13,3.354,28.459c0,3.334-10.646,5.512-10.646,0.083 c0-0.93-0.998-16.077-1.374-22.249c-0.387-6.183-7.104-26.498-7.104-26.498l15.858-4.902 C94.672,109.546,94.589,132.166,94.583,134.653z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#262626",
  d: "M69.077,175.201l11.609,1.054c0,0,1.35,5.704-1.429,6.295c-2.769,0.596-13.737,0.969-15.317,1.076 c-1.569,0.112-5.912-0.666-5.912-4.455C58.028,177.53,69.077,175.201,69.077,175.201z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.302,148.623c-0.706-4.741-1.474-32.54-1.474-32.54l15.061-1.635c0,0-2.126,22.839-2.634,31.245 c3.483,7.462,0.508,31.13,0.508,31.13s-7.885,1.938-13.153-1.953C72.252,171.284,70.902,152.717,70.302,148.623z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#262626",
  d: "M81.557,59.968c4.698,1.074,13.115-2.458,13.115-2.458s7.521,1.842,6.448,7.375 c0,8.85-8.142,17.513-8.142,23.122c0,8.917,4.773,18.355,3.697,20.963c-1.067,2.61-11.99,9.985-19.331,10.53 c-7.331,0.552-11.765-4.123-11.765-4.123s2.053-36.361,3.029-42.356C69.574,67.027,81.557,59.968,81.557,59.968z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C6B4",
  d: "M80.039,38.156l5.722,5.324l-0.853,10.211c0,0-5.447,1.687-7.242-0.071 c-0.403-0.205-0.436-7.905-0.049-10.519C78.006,40.497,80.039,38.156,80.039,38.156z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C6B4",
  d: "M66.598,114.448c0,0,4.87,0.97,4.87,1.669c0,2.184-1.463,3.762-2.467,4.634 c-0.392,0.338-0.713,0.255-0.984,0.814c-0.473,0.979-0.044,1.229,1.051,1.871c-0.994,1.405-4.704,0.185-5.435-0.466 c-0.734-0.648-1.449-1.201-1.534-2.919C62.031,118.341,66.598,114.448,66.598,114.448z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M72.91,113.225l-1.134,3.374c0,0-3.839,0.868-5.979-1.997c-0.103-0.406,0.913-3.479,0.913-3.479 L72.91,113.225z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.834,74.407c0,0,0.596-9.106,8.938-6.91c4.481,1.175,3.074,6.83,2.224,8.901c-0.851,2.076-1.461,17.593-2.699,20.535 c-1.233,2.947-4.987,14.763-5.565,16.498c-0.575,1.743-8.215,1.678-9.151-3.541c0.431-0.993,4.894-15.673,4.894-15.673 L71.834,74.407z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M94.282,55.89c0.312,0.315,0.312,0.315,0.39,1.62c0,2.381-15.642,4.084-15.642,4.084l0.792-2.85 C79.822,58.744,86.834,58.427,94.282,55.89z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#332C25",
  d: "M79.834,39.885c0.582-1.11-0.47-2.067,0.01-3.118c0.929-1.307,1.23-2.221,2.684-1.992 c2.381-4.839,13.436,0.6,14.063,8.367c1.098,13.646-6.078,14.831-6.078,14.831s-7.716,0.839-7.985-4.917c0-0.919,0-1.615,0-1.615 s0.121-3.417-2.488-3.648c-0.305-1.386-0.608-1.229-0.466-4.492C79.554,42.502,78.808,41.844,79.834,39.885z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0F0E0C",
  d: "M92.979,40.978c0,0-2.411-4.666-9.521-6.054C91.568,35.061,92.979,40.978,92.979,40.978z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C6B4",
  d: "M53.421,67.154h3.925l1.794,5.304l-1.794,1.373c0,0-4.265-0.542-5.259-4.652 C52.351,67.609,53.421,67.154,53.421,67.154z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C7A496",
  d: "M57.346,73.831c0,0-2.041,1.116-4.512-2.801c-0.023-0.24-0.509-1.159-0.241-1.193 C54.458,74.048,57.346,73.831,57.346,73.831z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C7A496",
  d: "M53.421,67.154c0,0,0.88,2.067,0.929,2.41c-2.354-0.205-0.486,3.042-3.019,3.025 c-1.018,0-3.166-3.183-1.553-4.979C50.816,66.444,53.421,67.154,53.421,67.154z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C6B4",
  d: "M53.421,67.154c0,0,1.695,2.259,0.929,2.41c-3.195-0.302-0.462,2.871-3.033,2.613 c-1.018-0.097-2.623-2.912-1.009-4.71C51.349,66.308,53.421,67.154,53.421,67.154z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C7A496",
  d: "M48.667,70.963c1.869,0.199,4.177,2.906,4.869,4.161c0.686,1.257-0.276,1.374-1.022,1.456 c-0.744,0.086-5.023-0.617-5.31-2.693C46.901,71.811,47.734,70.862,48.667,70.963z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0C6B4",
  d: "M48.814,71.491c1.7,0.179,3.803,2.646,4.431,3.787c0.634,1.143,0.362,1.471-0.324,1.543 c-0.676,0.082-5.604-0.954-5.876-2.846C46.776,72.089,47.962,71.402,48.814,71.491z"
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#FB7422",
  strokeWidth: 4.252,
  strokeMiterlimit: 10,
  cx: 51.5,
  cy: 70.493,
  r: 19
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 48.5,
  y: 51.265,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 64.4151 -15.9824)",
  fill: "#FB7422",
  width: 6,
  height: 37
});

var SvgBezZobowiazan = function SvgBezZobowiazan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "103px",
    height: "188px",
    viewBox: "0 0 103 188",
    enableBackground: "new 0 0 103 188",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBezZobowiazan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bez-zobowiazan.325898b7.svg";
export { ForwardRef as ReactComponent };